import React from "react";
import AdmTeacherTimeTable from "../../components/AdminTabs/AdminClassTimeTable/AdmTeacherTimeTable";

const DayBook = () => {
  return (
    <div>
      <AdmTeacherTimeTable />
    </div>
  );
};

export default DayBook;
